'use strict';

function Portal() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_PortalPresenter, _AnalyticsData];

  this.init = function () {
    this._super();
    this.analytics.update(this.analyticsData, this);

    this._inner = this.$node.find(this._classes.inner);
    this._nav = this.$node.find(this._classes.nav);
    this._nav_items = this.$node.find(this._classes.nav_items);
    this._mobile = this.$node.find(this._classes.nav_mobile);
    this._icon = this.$node.find(this._classes.nav_mobile_icon);
    this._content = this.$node.find(this._classes.content);
    this._toggle = this.$node.find(this._classes.nav_toggle);
    this._helpLinks = this.$node.find(this._classes.help_links);
  };

  this.initAllReady = function () {
    this._super();
    this.registerResponsiveFunction(this.activeRange, null, null);
    this.registerResponsiveFunction(this.resetNav, null, window.mogo.registry.mogoUI.config.mediaQueries.large);
    this.registerResponsiveFunction(this.openNav, window.mogo.registry.mogoUI.config.mediaQueries.large + 1, null);

    this._toggle.on('click', this.toggleNav.bind(this));
    this._helpLinks.on('click', this._onClickNavHelp.bind(this));
    this._nav_items.find('.js--logout').on('click', this._onLogout.bind(this));
    this._nav_items.find('.js--fr-logout').on('click', this._onFrLogout.bind(this));
    this._nav_items.find('.js--memberNav__inner_link-active').on('click', this.resetNav.bind(this)); // close nav

    this.$node.addClass(this._classes.collapsed);
    this.$node.show();
  };
  this._FR_LOGOUT_PATH = '/fr/login?notification=logged-out';
  this._onFrLogoutSuccess = function () {
    var redirect_path = this._FR_LOGOUT_PATH;
    window.location.replace(redirect_path);
  };
  this._onFrLogout = function (evt) {
    this._session.deleteSession($.proxy(this._onFrLogoutSuccess, this));
    if (evt) evt.preventDefault();
  };

  this.toggleNav = function () {
    if (!this._isExpanded()) {
      this.openNav();
    } else {
      this.resetNav();
    }
    return false;
  };

  this.openNav = function () {
    if (!this._isExpanded() && this.smallRange) {
      this.$node.removeClass(this._classes.collapsed).addClass(this._classes.expanded);
      this._icon.removeClass('icon-menu').addClass('icon--close'); // toggle icon
      this._nav.on('touchstart.resetNav click.resetNav', this._onClickNav.bind(this));
      document.body.addClass('scroll-freeze');
    }
  };

  this._isExpanded = function () {
    return this.$node.hasClass(this._classes.expanded);
  };

  this._onClickNav = function (evt) {
    if ($(evt.target).hasClass('portal__nav')) {
      this.resetNav();
    }
  };

  this.resetNav = function () {
    var _this = this;

    if (this._isExpanded() && this.smallRange) {
      this._inner.off(this._transitionEnd).on(this._transitionEnd, function (event) {
        if (_this._inner.is(event.target)) {
          if (!_this._isExpanded()) {
            _this.$node.addClass(_this._classes.collapsed);
          }
          _this._inner.off(_this._transitionEnd);
        }
      });

      this.$node.removeClass(this._classes.expanded);
      this._icon.removeClass('icon--close').addClass('icon-menu');
      this._nav.off('touchstart.resetNav');
      document.body.removeClass('scroll-freeze');

      // $(window).scrollTop(0); // reset page content position
    }
  };

  this._onClickNavHelp = function (e) {
    var helpCenterSections = {
      ACCOUNT: 'https://helpcentre.mogo.ca',
      CRYPTO: 'https://helpcentre.mogo.ca/hc/en-us/categories/360002937914-MogoCrypto'
    };
    var _helpCenterUrl = helpCenterSections[this.presenter.models.appState.layout.active_section];
    if (_helpCenterUrl !== undefined) {
      window.open(_helpCenterUrl, null);
      e.preventDefault();
    }
    this.analytics.forcePushEvent('generic-member-navigation', {
      memberNavigation: ['Help']
    });
  };
}